<div class="vc-page">

  <!-- ── Page header ──────────────────────────────────────────── -->
  <div class="vc-header">
    <div class="vc-header__left">
      <div class="vc-header__icon">
        <mat-icon>beach_access</mat-icon>
      </div>
      <div>
        <h1 class="vc-header__title">Vacaciones</h1>
        <p class="vc-header__sub">Gestiona las solicitudes y aprobaciones de vacaciones del equipo</p>
      </div>
    </div>
    <div class="vc-header__actions">
      <button mat-flat-button class="vc-btn-primary" (click)="create()">
        <mat-icon>add</mat-icon> Nueva vacación
      </button>
      <app-help key="Personal4"></app-help>
    </div>
  </div>

  <!-- ── Loading ──────────────────────────────────────────────── -->
  <div class="vc-loading" *ngIf="(VacacionesService.loading$ | async)">
    <div class="vc-loading__icon-wrap"><mat-icon>beach_access</mat-icon></div>
    <div class="vc-loading__dots"><span></span><span></span><span></span></div>
    <p class="vc-loading__text">Cargando vacaciones…</p>
  </div>

  <ng-container *ngIf="!(VacacionesService.loading$ | async)">

    <!-- ── Sección: Solicitudes pendientes ────────────────────── -->
    <div class="vc-section">
      <div class="vc-section__head">
        <span class="vc-pill vc-pill--pending"></span>
        <div>
          <h2 class="vc-section__title">Solicitudes pendientes</h2>
          <p class="vc-section__sub">Solicitudes realizadas por los empleados que están a la espera de aprobación</p>
        </div>
      </div>

      <div class="vc-empty"
           *ngIf="(vacacionesSolicitadas$ | async)?.length === 0">
        <div class="vc-empty__art"><mat-icon>event_available</mat-icon></div>
        <h3 class="vc-empty__title">Sin solicitudes pendientes</h3>
        <p class="vc-empty__sub">No hay solicitudes de vacaciones esperando aprobación.</p>
      </div>

      <div class="vc-card" *ngIf="(vacacionesSolicitadas$ | async)?.length > 0">
        <table mat-table [dataSource]="vacacionesSolicitadas$ | async" matSort class="vc-table">

          <ng-container matColumnDef="employee">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Empleado</th>
            <td mat-cell *matCellDef="let el">
              <div class="vc-cell-employee">
                <div class="vc-avatar">{{ nombreEmpleado(el.employees_Id) | slice:0:1 }}</div>
                <span>{{ nombreEmpleado(el.employees_Id) }}</span>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="cadenaInicio">
            <th mat-header-cell *matHeaderCellDef>Inicio</th>
            <td mat-cell *matCellDef="let el"><span class="vc-date">{{ el.cadenaInicio }}</span></td>
          </ng-container>

          <ng-container matColumnDef="cadenaFin">
            <th mat-header-cell *matHeaderCellDef>Fin</th>
            <td mat-cell *matCellDef="let el"><span class="vc-date">{{ el.cadenaFin }}</span></td>
          </ng-container>

          <ng-container matColumnDef="motivo">
            <th mat-header-cell *matHeaderCellDef>Motivo</th>
            <td mat-cell *matCellDef="let el">{{ el.motivo || '—' }}</td>
          </ng-container>

          <ng-container matColumnDef="cadenaFechaSolicitud">
            <th mat-header-cell *matHeaderCellDef>Solicitud</th>
            <td mat-cell *matCellDef="let el"><span class="vc-date">{{ el.cadenaFechaSolicitud }}</span></td>
          </ng-container>

          <ng-container matColumnDef="acciones">
            <th mat-header-cell *matHeaderCellDef class="vc-col-actions"></th>
            <td mat-cell *matCellDef="let el" class="vc-col-actions">
              <button mat-icon-button [matMenuTriggerFor]="menuSolicitadas" (click)="setRow(el)"
                      class="vc-menu-trigger" matTooltip="Acciones">
                <mat-icon>more_vert</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let r; columns: displayedColumns;" class="vc-row"></tr>
        </table>
      </div>
    </div>

    <!-- ── Sección: Vacaciones aprobadas ──────────────────────── -->
    <div class="vc-section">
      <div class="vc-section__head">
        <span class="vc-pill vc-pill--approved"></span>
        <div>
          <h2 class="vc-section__title">Vacaciones aprobadas</h2>
          <p class="vc-section__sub">Solicitudes ya aprobadas. Las vacaciones creadas desde aquí quedan aprobadas automáticamente</p>
        </div>
      </div>

      <div class="vc-empty"
           *ngIf="(vacacionesAprobadas$ | async)?.length === 0">
        <div class="vc-empty__art"><mat-icon>beach_access</mat-icon></div>
        <h3 class="vc-empty__title">Sin vacaciones aprobadas</h3>
        <p class="vc-empty__sub">Aún no se ha aprobado ninguna solicitud de vacaciones.</p>
      </div>

      <div class="vc-card" *ngIf="(vacacionesAprobadas$ | async)?.length > 0">
        <table mat-table [dataSource]="vacacionesAprobadas$ | async" matSort class="vc-table">

          <ng-container matColumnDef="employee">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Empleado</th>
            <td mat-cell *matCellDef="let el">
              <div class="vc-cell-employee">
                <div class="vc-avatar">{{ nombreEmpleado(el.employees_Id) | slice:0:1 }}</div>
                <span>{{ nombreEmpleado(el.employees_Id) }}</span>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="cadenaInicio">
            <th mat-header-cell *matHeaderCellDef>Inicio</th>
            <td mat-cell *matCellDef="let el"><span class="vc-date">{{ el.cadenaInicio }}</span></td>
          </ng-container>

          <ng-container matColumnDef="cadenaFin">
            <th mat-header-cell *matHeaderCellDef>Fin</th>
            <td mat-cell *matCellDef="let el"><span class="vc-date">{{ el.cadenaFin }}</span></td>
          </ng-container>

          <ng-container matColumnDef="motivo">
            <th mat-header-cell *matHeaderCellDef>Motivo</th>
            <td mat-cell *matCellDef="let el">{{ el.motivo || '—' }}</td>
          </ng-container>

          <ng-container matColumnDef="cadenaFechaSolicitud">
            <th mat-header-cell *matHeaderCellDef>Solicitud</th>
            <td mat-cell *matCellDef="let el"><span class="vc-date">{{ el.cadenaFechaSolicitud }}</span></td>
          </ng-container>

          <ng-container matColumnDef="acciones">
            <th mat-header-cell *matHeaderCellDef class="vc-col-actions"></th>
            <td mat-cell *matCellDef="let el" class="vc-col-actions">
              <button mat-icon-button [matMenuTriggerFor]="menuAprobadas" (click)="setRow(el)"
                      class="vc-menu-trigger" matTooltip="Acciones">
                <mat-icon>more_vert</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let r; columns: displayedColumns;" class="vc-row"></tr>
        </table>
      </div>
    </div>

    <!-- ── Sección: Por empleado ──────────────────────────────── -->
    <div class="vc-section">
      <div class="vc-section__head">
        <span class="vc-pill vc-pill--search"></span>
        <div>
          <h2 class="vc-section__title">Historial por empleado</h2>
          <p class="vc-section__sub">Consulta todas las vacaciones de un empleado concreto, con su estado</p>
        </div>
      </div>

      <!-- Filtro -->
      <div class="vc-filter-card" *ngIf="formBusqueda !== null && empleados?.length > 0">
        <div class="vc-filter-card__head">
          <mat-icon class="vc-filter-card__icon">search</mat-icon>
          <span class="vc-filter-card__label">Buscar por empleado</span>
        </div>
        <form [formGroup]="formBusqueda" class="vc-filter-form">
          <mat-form-field appearance="outline" class="vc-filter-field">
            <mat-label>Empleado</mat-label>
            <mat-select formControlName="employees_Id">
              <mat-option *ngFor="let e of empleados; trackBy: trackByIndex" [value]="e.uid">
                {{ e.name }}
              </mat-option>
            </mat-select>
            <mat-hint>Selecciona el empleado para ver su historial de vacaciones</mat-hint>
            <mat-error *ngIf="formBusqueda.controls['employees_Id'].hasError('required')">
              El empleado es <strong>obligatorio</strong>
            </mat-error>
          </mat-form-field>
          <div class="vc-filter-actions">
            <button mat-flat-button class="vc-btn-primary" type="button"
                    (click)="obtenerVacacionesPorEmpleado()">
              <mat-icon>search</mat-icon> Buscar
            </button>
            <button mat-stroked-button class="vc-btn-ghost" type="button" (click)="cancelar()"
                    *ngIf="vacacionesPorEmpleado?.length > 0">
              <mat-icon>close</mat-icon> Limpiar
            </button>
          </div>
        </form>
      </div>

      <!-- Resultados -->
      <div class="vc-card" *ngIf="vacacionesPorEmpleado?.length > 0">
        <table mat-table [dataSource]="vacacionesPorEmpleado" matSort class="vc-table">

          <ng-container matColumnDef="cadenaInicio">
            <th mat-header-cell *matHeaderCellDef>Inicio</th>
            <td mat-cell *matCellDef="let el"><span class="vc-date">{{ el.cadenaInicio }}</span></td>
          </ng-container>

          <ng-container matColumnDef="cadenaFin">
            <th mat-header-cell *matHeaderCellDef>Fin</th>
            <td mat-cell *matCellDef="let el"><span class="vc-date">{{ el.cadenaFin }}</span></td>
          </ng-container>

          <ng-container matColumnDef="motivo">
            <th mat-header-cell *matHeaderCellDef>Motivo</th>
            <td mat-cell *matCellDef="let el">{{ el.motivo || '—' }}</td>
          </ng-container>

          <ng-container matColumnDef="cadenaFechaSolicitud">
            <th mat-header-cell *matHeaderCellDef>Solicitud</th>
            <td mat-cell *matCellDef="let el"><span class="vc-date">{{ el.cadenaFechaSolicitud }}</span></td>
          </ng-container>

          <ng-container matColumnDef="nombreEstado">
            <th mat-header-cell *matHeaderCellDef>Estado</th>
            <td mat-cell *matCellDef="let el">
              <span class="vc-estado-badge" [class.vc-estado-badge--ok]="el.nombreEstado === 'Aprobada'"
                    [class.vc-estado-badge--warn]="el.nombreEstado !== 'Aprobada'">
                {{ el.nombreEstado }}
              </span>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumnsByEmployee"></tr>
          <tr mat-row *matRowDef="let r; columns: displayedColumnsByEmployee;" class="vc-row"></tr>
        </table>
      </div>
    </div>

  </ng-container>

</div>

<!-- ── Menús ─────────────────────────────────────────────────── -->
<mat-menu #menuSolicitadas="matMenu">
  <button mat-menu-item (click)="editar()">
    <mat-icon>edit</mat-icon><span>Editar</span>
  </button>
  <mat-divider></mat-divider>
  <button mat-menu-item class="vc-action-danger" (click)="eliminar()">
    <mat-icon>delete</mat-icon><span>Borrar</span>
  </button>
</mat-menu>

<mat-menu #menuAprobadas="matMenu">
  <button mat-menu-item (click)="editar()">
    <mat-icon>edit</mat-icon><span>Editar</span>
  </button>
  <mat-divider></mat-divider>
  <button mat-menu-item class="vc-action-danger" (click)="eliminar()">
    <mat-icon>delete</mat-icon><span>Borrar</span>
  </button>
</mat-menu>
